import { render, staticRenderFns } from "./SupplierStoreReceipts.vue?vue&type=template&id=f1dc645e&scoped=true"
import script from "./SupplierStoreReceipts.vue?vue&type=script&lang=js"
export * from "./SupplierStoreReceipts.vue?vue&type=script&lang=js"
import style0 from "./SupplierStoreReceipts.vue?vue&type=style&index=0&id=f1dc645e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dc645e",
  null
  
)

export default component.exports